// src/App.js

import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import AuthProvider from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AppLayout from "./components/AppLayout";

import Login from "./pages/LoginSSO";    
import Overview from "./pages/Overview";
import MyCertifications from "./pages/MyCertifications";
import Leaderboard from "./pages/Leaderboard";
import OrgCertDashboard from "./pages/OrgCertDashboard";
import Quiz from "./pages/Quiz";
import AzureCallback from "./pages/AzureCallback";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" />

        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/callback" element={<AzureCallback />} />

          <Route
            path="/app"
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="overview" replace />} />
            <Route path="overview" element={<Overview />} />
            <Route path="my-certs" element={<MyCertifications />} />
            <Route path="leaderboard" element={<Leaderboard />} />
            <Route path="quiz" element={<Quiz />} />
            <Route path="org-dashboard" element={<OrgCertDashboard />} />
          </Route>

          <Route path="/" element={<Navigate to="/app" replace />} />
          <Route path="*" element={<Navigate to="/app" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

